var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 32,
    viewBox: "0 0 83 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29848_17848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2997 18.6176H42.3082L41.165 21.3833H38.1047L43.8557 8.47839H46.8044L52.5764 21.3833H49.4395L48.2997 18.6176ZM47.3604 16.3521L45.3144 11.4114L43.2667 16.3521H47.3604Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.859 11.6868C58.5008 11.4298 59.1876 11.3042 59.8788 11.3173V13.9715C59.5581 13.9471 59.3438 13.9349 59.2322 13.9349C58.4097 13.9349 57.7648 14.1673 57.2978 14.632C56.8307 15.0967 56.5984 15.788 56.6007 16.7059V21.3886H53.72V11.4655H56.4683V12.7743C56.8203 12.2881 57.3023 11.9112 57.859 11.6868Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.851 17.4936L64.469 18.8581V21.3833H61.5935V7.70465H64.469V15.4476L68.6725 11.4655H72.1021L67.9719 15.6742L72.4698 21.3886H68.9844L65.851 17.4936Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2809 20.8762C74.4671 20.4663 73.7839 19.8374 73.3081 19.0602C72.8436 18.2595 72.5989 17.3501 72.5989 16.4244C72.5989 15.4986 72.8436 14.5893 73.3081 13.7885C73.7839 13.0114 74.4671 12.3825 75.2809 11.9726C76.1649 11.525 77.1448 11.3001 78.1355 11.3173C79.0894 11.295 80.0328 11.5208 80.8733 11.9726C81.6348 12.3875 82.235 13.0459 82.5777 13.8425L80.347 15.0415C79.8312 14.1318 79.0876 13.677 78.1163 13.677C77.7722 13.6664 77.4296 13.7263 77.1095 13.8531C76.7894 13.9799 76.4986 14.1708 76.2551 14.4141C75.766 14.9056 75.5214 15.5754 75.5214 16.4235C75.5214 17.2716 75.7671 17.942 76.2586 18.4346C76.5021 18.6779 76.7929 18.8689 77.113 18.9957C77.433 19.1224 77.7757 19.1824 78.1198 19.1718C79.1027 19.1718 79.8463 18.7169 80.3505 17.8072L82.5812 19.0271C82.2284 19.8105 81.6301 20.4577 80.8768 20.8709C80.0367 21.3274 79.0913 21.5552 78.1355 21.5314C77.1448 21.5487 76.1649 21.3237 75.2809 20.8762Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5889 0H10.4111C7.64988 0 5.00179 1.09688 3.04933 3.04933C1.09688 5.00178 0 7.64988 0 10.4111V21.5889C0 24.3501 1.09688 26.9982 3.04933 28.9507C5.00179 30.9031 7.64988 32 10.4111 32H21.5889C24.3501 32 26.9982 30.9031 28.9507 28.9507C30.9031 26.9982 32 24.3501 32 21.5889V10.4111C32 7.64988 30.9031 5.00178 28.9507 3.04933C26.9982 1.09688 24.3501 0 21.5889 0ZM9.5641 22.4446L11.6101 17.504L14.5047 20.3986L9.5641 22.4446ZM16.2283 21.5732L17.3663 18.811L13.1315 14.5814L10.3675 15.7281L8.20477 13.5637L21.3972 8.50975L23.4885 10.601L18.4433 23.8074L16.2283 21.5732Z",
    fill: "#8C52FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29848_17848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.5723,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.a7bc2fed8aa23e60a2829ee815f3e466.svg";
export { ForwardRef as ReactComponent };